import { defineStore } from "pinia";
import { computed, reactive, ref, watch, watchEffect } from "vue";
import { getVacancies } from "@/lib/queries/get-vacancies.js";
import { useQuery } from "@vue/apollo-composable";
import { getFilters } from "@/lib/queries/get-filters.js";
import { getParamFromSearch } from "@/lib/getParamFromSearch.js";

export const useVacancies = defineStore("Vacancies", function () {
  const filter = reactive({
    _search: "",
    region: getParamFromSearch("region") ?? "", // Здесь подставляем регион по умолчанию
    schedule: "",
    experience: "",
    employment: "",
    area: "",
  });
  const keywordOptions = ref([]);

  watchEffect(function () {
    if (document.forms?.form740538760?.elements?.region) {
      document.forms.form740538760.elements.region.value =
        filter.region || "Неизвестен";
    }
  });

  /*
   * Блок получения фильтров
   * */

  const filters = ref([]);

  const { result: _filters, loading: loadingFilters } = useQuery(getFilters);

  watch(_filters, (value) => {
    const temp = [];

    if (value.regions.length > 0) {
      temp.push({
        key: "region",
        title: "Регион",
        type: "datalist",
        defaultOpen: true,
        options: value.regions,
        defaultValue: filter.region,
      });
    }

    if (value.employments.length > 0) {
      temp.push({
        key: "employment",
        title: "Тип занятости",
        type: "radio",
        defaultOpen: true,
        options: value.employments,
      });
    }

    if (value.experiences.length > 0) {
      temp.push({
        key: "experience",
        title: "Опыт работы",
        type: "radio",
        defaultOpen: false,
        options: value.experiences,
      });
    }

    if (value.schedules.length > 0) {
      temp.push({
        key: "schedule",
        title: "График работы",
        type: "radio",
        defaultOpen: false,
        options: value.schedules,
      });
    }

    if (value.areas.length > 0) {
      temp.push({
        key: "area",
        title: "Сфера деятельности",
        type: "radio",
        defaultOpen: false,
        options: value.areas,
      });
    }

    filters.value = temp;

    if (value.vacancies.length > 0) {
      keywordOptions.value = value.vacancies;
    }
  });

  /*
   * Блок получения вакансий
   * */

  const vacancies = ref([]);

  const {
    onResult: onResultVacancies,
    loading: loadingVacancies,
    refetch,
  } = useQuery(getVacancies, filter);

  onResultVacancies((result) => {
    if (Array.isArray(result.data?.vacancies))
      vacancies.value = result.data.vacancies;
  });

  watch(filter, (value) => {
    refetch(value);
  });

  /*
   * Вспомогательные свойства/методы
   * */

  const count = computed(() =>
    Array.isArray(vacancies.value) ? vacancies.value.length : 0,
  );

  function applyFilter(key, value) {
    filter[key] = value;
  }

  function resetFilters() {
    filter.schedule = "";
    filter.experience = "";
    filter.employment = "";
    filter.area = "";
  }

  const disabledReset = computed(
    () =>
      filter.schedule === "" &&
      filter.experience === "" &&
      filter.employment === "" &&
      filter.area === "",
  );

  return {
    filters,
    loadingFilters,
    loadingVacancies,
    count,
    vacancies,
    applyFilter,
    resetFilters,
    disabledReset,
    keywordOptions,
  };
});
